export default {
  roles: [],
  selectedRole: {},
  permissions: [],
  permissions_page: 0,
  permissions_pages: [],
  permissions_per_page: 15,
  allPermissions: [],
}